import script from "./displayList.vue?vue&type=script&setup=true&lang=js"
export * from "./displayList.vue?vue&type=script&setup=true&lang=js"

import "./displayList.vue?vue&type=style&index=0&id=4c4d12e0&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4d12e0"]])

export default __exports__